import React from 'react';
import { MAIL_AWAY_STATUS_CONFIG, getEffectiveMailAwayStatus, daysPastFollowUp } from './mailAwayStatus';

export const MailAwayStatusBadge = ({ request, status, testId }) => {
  const effective = request ? getEffectiveMailAwayStatus(request) : (status || 'not_sent');
  const cfg = MAIL_AWAY_STATUS_CONFIG[effective] || MAIL_AWAY_STATUS_CONFIG.not_sent;
  const Icon = cfg.icon;
  const days = effective === 'overdue' ? daysPastFollowUp(request) : 0;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-md border ${cfg.color}`}
      title={effective === 'overdue' ? 'Follow-up date has passed' : ''}
      data-status={effective} data-testid={testId}>
      <Icon size={10} />
      {cfg.label}{days ? ` (${days}d)` : ''}
    </span>
  );
};

export default MailAwayStatusBadge;
